import styled from '@emotion/styled';

export const StyledContainer = styled('div')(
  ({ openMenu }: { openMenu: boolean }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    maxHeight: '100dvh',
    height: openMenu ? '100dvh' : 'auto',
  }),
);
